<template>
  <!-- eslint-disable -->
  <div>
    <CardShadow v-if="participants.length > 10">
      <div class="row m-0 ticket py-3 font-xs align-items-center">
        <div class="col-6">
          <p class="mb-0"><b>CARGA MASIVA</b></p>
        </div>
        <div class="col-6 text-right">
          <a href="/download/Plantilla_Subir_Participantes.xlsx"><b>DESCARGAR PLANTILLA XLS</b></a>
        </div>
      </div>
    </CardShadow>

    <div v-for="event in tickets" :key="event.activityId">
      <CardShadow>
        <div class="row">
          <div class="col-6 col-lg-5 py-0 pr-0">
            <CardLogoVs
              class="card-logo-dark"
              logoVs="/images/logo-vs.png"
              :nameVs="versus.smallSecond"
              :date="dateEvent"
              :hour="dateHourEvent"
            />
          </div>
          <div class="col-6 col-lg-7 my-auto">
            <h4 class="m-3 ticket__title">
              Mis entradas
            </h4>
          </div>
        </div>
      </CardShadow>
      <div class="text-right mb-3" v-if="hasEmitBtn(event)">
        <button
          @click="modalEmit(event)"
          class="btn btn-action text-uppercase"
          type="button"
        >
          <b>Imprimir/Enviar mis entradas</b>
        </button>
      </div>
      <div role="tablist" class="mb-4">
        <b-card
          v-for="ticketType in event.data"
          :key="ticketType.ticketTypeId"
          no-body
          class="mb-1 border-0"
        >
          <b-card-header header-tag="header"
            class="p-2 card-header--white card-header--west" role="tab">
            <div
              v-b-toggle="`accordion-${ticketType.ticketTypeId + event.activityId}`"
              class="row m-0 align-items-center">
              <div class="col-12 col-lg-5 mb-2 mb-md-0">
                <span><b>{{ ticketType.ticketTypeName }}</b></span>
              </div>
              <div class="col-5 col-lg-3">
                <span><b>
                  entradas x
                  {{ ticketType.data.length }}
                </b></span>
              </div>
              <div class="col-7 col-lg-4 pr-0 text-right">
                <button
                  type="button"
                  class="btn btn-secondary"
                  v-if="participants.length > 10"
                  @click.stop="modalUpload(event, ticketType)"
                >
                  SUBIR XLS
                </button>
                <!-- <span class="mx-3">
                  <b><i class="fa fa-angle-up" style="font-size:25px"></i></b>
                </span> -->
                <span class="mx-3">
                  <b><i class="fa fa-angle-down" style="font-size:25px"></i></b>
                </span>
              </div>
            </div>
          </b-card-header>
          <b-collapse
            :id="`accordion-${ticketType.ticketTypeId + event.activityId}`"
            :accordion="`accordion-${event.activityId}`"
            visible
            role="tabpanel" style="background:#f0f0f0;"
          >
            <div
              v-for="(participant, idx) in ticketType.data"
              :key="participant.code"
              class="mt-2"
            >
              <Ticket
                :participant="participant"
                :email="event.email"
                :index="idx"
                @update="$emit('update', $event)"
                @onViewTicketList="onViewTicketList($event)"
                class="card-header--white west"
              />
            </div>
          </b-collapse>
        </b-card>
      </div>
    </div>

    <div role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1 card-header--white" role="tab">
          <div block href="#" v-b-toggle.accordion-1 variant="info"
            class="p-2 d-flex justify-content-between align-items-center">
            <span><b>¿Qué pasa si no voy al estadio?</b></span>
            <span
              class="float-right font-xs"
              v-if="collapse.shown && collapse.id === 'accordion-1'">
              <b>CERRAR</b></span>
            <span
              class="float-right font-xs"
              v-else>
              <b>ABRIR</b></span>
          </div>
        </b-card-header>
        <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>
              Pierdes tu entrada y el dinero, no se realizan devoluciones
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1 card-header--white" role="tab">
          <div block href="#" v-b-toggle.accordion-2 variant="info"
            class="p-2 d-flex justify-content-between align-items-center">
            <span><b>¿Cómo debo presentar mis entradas en el estadio?</b></span>
            <span
              class="float-right font-xs"
              v-if="collapse.shown && collapse.id === 'accordion-2'">
              <b>CERRAR</b></span>
            <span
              class="float-right font-xs"
              v-else>
              <b>ABRIR</b></span>
          </div>
        </b-card-header>
        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text>
              Las entradas se presentan impresas en cualquier tipo de papel
              siempre y cuando la información sea legible además se debe
              presentar junto al documento de identidad físico
              (DNI, pasaporte, carné de extranjería)
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1 card-header--white" role="tab">
          <div block href="#" v-b-toggle.accordion-3 variant="info"
            class="p-2 d-flex justify-content-between align-items-center">
            <span><b>¿Conoce las restricciones de acceso?</b></span>
            <span
              class="float-right font-xs"
              v-if="collapse.shown && collapse.id === 'accordion-3'">
              <b>CERRAR</b></span>
            <span
              class="float-right font-xs"
              v-else>
              <b>ABRIR</b></span>
          </div>
        </b-card-header>
        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <h5>
              <b>PROHIBICIONES PARA LOS ESPECTADORES Y
              ORGANIZADORES DE LOS ESPECTÁCULOS DEPORTIVOS PROFESIONALES</b>
            </h5>
            <p>
              <b>a)</b> Usar o ingresar con banderolas, emblemas, pancartas;
              así como objetos o productos que por su contenido, peligrosidad,
              rigidez o dimensiones, inciten a conductas intolerantes,
              discriminatorias, violentas, racistas o xenófobas en el
              interior de los escenarios deportivos, que puedan afectar
              la integridad de cualquiera de los espectadores,
              su patrimonio, así como la infraestrustura del escenario deportivo.
            </p>
            <p>
              <b>b)</b> Usar pintura facial, prendas o accesorios
              que dificulten la debida identificación de los espectadores.
            </p>
            <div class="text-right">
              <a :href="restrictionsPdf" target="_blank">Ver más información</a>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1 card-header--white" role="tab">
          <div block href="#" v-b-toggle.accordion-4 variant="info"
            class="p-2 d-flex justify-content-between align-items-center">
            <span><b>Recomendaciones</b></span>
            <span
              class="float-right font-xs"
              v-if="collapse.shown && collapse.id === 'accordion-4'">
              <b>CERRAR</b></span>
            <span
              class="float-right font-xs"
              v-else>
              <b>ABRIR</b></span>
          </div>
        </b-card-header>
        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <h5>
              <b>RECOMENDACIONES PARA LOS ASISTENTES A LOS ESPECTÁCULOS DEPORTIVOS</b>
            </h5>
            <p>
              <b>a)</b> En caso de alguna emergencia, usted deberá identificar
              las salidas de evacuación y deberá dirigirse a la zona de seguridad.
            </p>
            <p>
              <b>b)</b> Para la evacuación del estadio, usted deberá conocer
              el número de fila de su asiento, para dirigirse a la zona de
              seguridad ubicada en la parte interna o externa del estadio.
            </p>
            <div class="text-right">
              <a :href="restrictionsPdf" target="_blank">Ver más información</a>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>

    </div>

    <b-modal v-model="modalEmitConfirm" hide-header hide-footer size="md" centered>
      <div class="d-block p-5">
        <h4>¿Estas seguro de emitir las entradas con los datos actuales?</h4>
        <hr>
        <p class="lead">
          Una vez emitidas las entradas <b>no podrás modificar los datos y te enviaremos una copia de estas a tu email</b>.
        </p>
        <h5>
          <b>Recuerda:</b> que puedes editar y emitir tus entradas hasta el mismo día del evento.
        </h5>
      </div>
      <a href="#" @click.prevent="modalEmitConfirm = false" class="btn-close-modal">
        <i class="fa fa-times text-dark"></i>
      </a>
      <button type="button" :disabled="loading" @click="confirmEmit()"
        class="btn px-5 btn-primary btn-submit-modal rounded-0">
        CONFIRMAR Y VER MIS ENTRADAS
      </button>
    </b-modal>

    <b-modal id="modal-upload" hide-header hide-footer size="md" centered>
      <div class="d-block p-5">
        <h4>Sube tu lista completa en tu documento XLS</h4>
        <hr>
        <div class="form-group">
          <label class="text-uppercase font-xs">DOCUMENTO XLS</label>
          <b-form-file
            v-model="file"
            placeholder="Seleccione archivo"
            style="overflow:hidden"
            accept=".xls, .xlsx"
          ></b-form-file>
          <div class="mt-2 text-success text-center" v-if="file">Archivo seleccionado</div>
          <div class="text-danger text-center font-xs">  {{ error }} </div>
        </div>
        <div class="mt-3 text-center">
          <small><b>Estás en la lista de {{ currentUpload.ticketTypeName }}</b></small>
        </div>
      </div>
      <a href="#" @click.prevent="$bvModal.hide('modal-upload')" class="btn-close-modal-intern">
        <i class="fa fa-times text-dark"></i>
      </a>
      <div class="col-12 text-center">
        <button type="button" name="button"  @click="uploadFile()"
        class="btn btn-sm py-2 px-5 btn-primary">
        <b-spinner v-if="loading" small class="mr-1"></b-spinner>
        ENVIAR DATOS
      </button>
      </div>
    </b-modal>
  </div>

</template>

<script>
import api from '../api';

const validateSeat = (seat) => {
  if (!seat) return true;
  const result = seat.split('_').find(val => val === 'SEAT');
  return !result;
};

export default {
  props: ['tickets', 'participants'],
  data() {
    return {
      transactionId: this.$route.params.id,
      activity: {},
      currentUpload: {},
      collapse: {
        id: '',
        shown: '',
      },
      loading: false,
      file: null,
      error: '',
      modalEmitConfirm: false,
    };
  },
  mounted() {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (isJustShown) {
        this.collapse.id = collapseId;
        this.collapse.shown = isJustShown;
      }
      if (!isJustShown && this.collapse.id === collapseId) {
        this.collapse.shown = isJustShown;
      }
    });
  },
  methods: {
    hasEmitBtn(event) {
      const res = event.data.map(el => el.data).reduce((a, b) => a.concat(b));
      const hasChange = res.every(i => i.change);
      const hasCodes = res.every(i => i.code);
      const hasSeats = res.every(i => validateSeat(i.seat));
      return !hasChange && hasCodes && hasSeats;
    },
    onViewTicketList(data) {
      this.$emit('viewTicket', data);
    },
    modalEmit(event) {
      this.activity = event;
      this.modalEmitConfirm = true;
    },
    async confirmEmit() {
      this.loading = true;
      const { activity, transactionId } = this;
      const payload = {
        transactionId,
        activityId: activity.activityId,
      };
      const url = '/code-exchange/emit-tickets';
      const { data: res } = await api.axios.post(url, payload);
      this.loading = false;
      if (res.success) {
        this.$emit('update', {});
        this.modalEmitConfirm = false;
        const res2 = activity.data.map(el => el.data).reduce((a, b) => a.concat(b));
        const res3 = res2.filter(el => el.paymentMethod !== 'transfer' && el.paymentMethod !== 'free');
        const payload2 = {
          data: res2,
          email: activity.email,
        };
        if (res3.length) {
          this.sendTicketsPdf(payload2);
        }
        res2.forEach((item) => {
          if (item.email) {
            const payloadUser = {
              data: [item],
              email: item.email,
            };
            this.sendTicketsPdf(payloadUser);
          }
        });
      }
    },
    async sendTicketsPdf(payload) {
      const noEmails = ['crafael@bbva.com', 'katherine.davila@fpf.org.pe'];
      const noEmail = noEmails.some(el => el === payload.email);
      if (noEmail) return;
      const url = '/code-exchange/send-email-tickets';
      await api.axios.post(url, { payload });
    },
    modalUpload(event, ticket) {
      this.error = '';
      this.currentUpload = {
        activityId: event.activityId,
        ticketTypeId: ticket.ticketTypeId,
        ticketTypeName: ticket.ticketTypeName,
      };
      this.$bvModal.show('modal-upload');
    },
    uploadFile() {
      this.loading = true;
      const formData = new FormData();
      const url = '/code-exchange/upload-file';
      formData.append('import_file', this.file);
      formData.append('transactionId', this.transactionId);
      formData.append('ticketTypeId', this.currentUpload.ticketTypeId);
      formData.append('activityId', this.currentUpload.activityId);

      api.axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((res) => {
        this.loading = false;
        const { message, status } = res.data;
        if (!status) {
          this.error = message;
          this.file = null;
          return;
        }
        window.location.reload();
      }).catch(() => {
        this.error = 'Error al subir archivo.';
        this.loading = false;
      });
    },
  },
};
</script>
